import { WrenchIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormRow } from 'src/ui/wards/common/form/FormRow';
import { TabBar, TabBarItem } from 'src/ui/wards/common/tabBar/TabBar';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';

export type ProductDetailsSectionItem = {
  placeholder: string;
  value: string | React.ReactNode;
};

export type ProductDetailsSection = {
  key: string;
  title: string;
  items: ProductDetailsSectionItem[];
};

export type ProductDetailsListProps = {
  sections: ProductDetailsSection[];
  stickyOffsetTop?: number;
};

export function ProductDetailsList({ sections, stickyOffsetTop = 0 }: ProductDetailsListProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  function handleEditProduct() {
    wardsNavigate(navigate, WaScreensMap[WA_Screen.EditProduct].path);
  }

  const backNavigation = () => {
    navigate(-1);
  };

  const tabBarItems: TabBarItem[] = [
    {
      icon: WrenchIcon,
      title: t('wards.tabBar.edit'),
      onClick: handleEditProduct,
    },
    {
      icon: WrenchIcon,
      title: t('wards.common.back'),
      onClick: backNavigation,
    },
  ].filter((i): i is TabBarItem => Boolean(i));

  return (
    <div
      className="flex flex-col gap-4 bg-gray-100"
      style={{ '--sticky-top': `${stickyOffsetTop}px` } as React.CSSProperties}
    >
      <div className="flex-1 overflow-y-auto bg-white">
        <div className="flex flex-col gap-2">
          {sections.map((section) => (
            <div key={section.key}>
              <div className="sticky top-[var(--sticky-top)] z-10 border-b border-gray-300 bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-800">
                {section.title}
              </div>
              <div className="divide-y divide-gray-200">
                {section.items.map((item, idx) => (
                  <div key={idx} className="px-4 py-3">
                    <FormRow title={item.placeholder} layout="vertical">
                      <div className="text-sm text-gray-700">{item.value}</div>
                    </FormRow>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="sticky bottom-0 z-50 bg-gray-100 py-4">
        <TabBar items={tabBarItems} />
      </div>
    </div>
  );
}

export default ProductDetailsList;
